import { EnvironmentBase } from './environment-base';
export class Environment extends EnvironmentBase {
  static production = true;
}

export const environment = Environment;
